export const DangerIcon = () => (
    <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M8 6V9.33333'
            stroke='#D92D20'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M7.99833 14.2733H3.95833C1.64499 14.2733 0.678328 12.62 1.79833 10.6L3.87833 6.85333L5.83833 3.33333C7.02499 1.19333 8.97166 1.19333 10.1583 3.33333L12.1183 6.86L14.1983 10.6067C15.3183 12.6267 14.345 14.28 12.0383 14.28H7.99833V14.2733Z'
            stroke='#D92D20'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M7.99609 11.3333H8.00208'
            stroke='#D92D20'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);
